import { PROVIDER_CONNECTION_TYPE } from "../misc";
import React, { useMemo } from "react";
import {
    useCategoryContext,
    useProviderComparePageContext,
    useProviderInfoPageContext
} from "../../Components/Context";
import { Paragraph } from "../../Components/Paragraph";

export const CategorySupportingInfo: React.FC<{}> = () => {
    const { category } = useCategoryContext();
    const { provider } = useProviderInfoPageContext();
    const { provider: comparisonProvider, toProvider: comparisonToProvider } = useProviderComparePageContext();

    const supportingInfo = useMemo(() => {
        return category?.supportingInfo;
    }, [category]);

    const bulkSupportingInfo = useMemo(() => {
        const providers = [provider, comparisonProvider, comparisonToProvider].filter(d => d != null);
        const allBulks =
            providers?.length > 0 &&
            providers.filter(d => d?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk)?.length ===
                providers?.length;

        return allBulks ? category?.bulkSupportingInfo : null;
    }, [category, provider, comparisonProvider, comparisonToProvider]);

    const _supportingInfo =
        bulkSupportingInfo?.processed != null && bulkSupportingInfo?.processed?.trim() !== ""
            ? bulkSupportingInfo
            : supportingInfo;

    if (!_supportingInfo) return null;

    return <>{_supportingInfo != null && <Paragraph nid={-1} title={""} status={true} text={_supportingInfo} />}</>;
};
